<div class="carousel-wrapper">
  <button class="custom-nav-button prev-button" (click)="prevSlide()">
              <i class="fas fa-solid fa-arrow-left"></i>
  </button>
  <!--Carousel-->
    <div class="carousel-container">
    <owl-carousel-o id="side-owl" name="side-owl" #owlCarousel [options]="customOptions">
      <ng-container *ngFor="let loc of slides ; let i = index">
        <ng-template carouselSlide [id]="">
          <div class="location-item-02 bg-holder text-center" style="background-image: url({{loc.cf_images[0]?.mx_image}});" ></div>

                      <div *ngIf="loc.cf_price === loc.cf_newPrice" class="NowPrice">
                          &nbsp;&nbsp;&nbsp;&nbsp;{{ loc.cf_currency }} {{ loc.cf_price }}&nbsp;&nbsp;&nbsp;&nbsp;    
                      </div>
                      <div *ngIf="loc.cf_price !== loc.cf_newPrice">
                        <div class="Specialdiscount strikethrough-text">
                            &nbsp;&nbsp;Was {{ loc.cf_currency }} {{ loc.cf_price }}&nbsp;&nbsp;&nbsp;
                        </div>
                        <div class="NowPrice">
                            &nbsp;&nbsp;Now {{ loc.cf_currency }} {{ loc.cf_newPrice }}&nbsp;&nbsp;
                        </div>
                      </div>
                        <div class="listing-item">
                          <div class="listing-details">
                            <div class="listing-details-inner-small" style="min-height:100px;">
                              <div class="listing-title">
                                <h6>{{loc.cf_product.title.substring(0,60)}}</h6>
                              </div>
                              <div class="listing-info">
                                <h6 style="font-size:1.9vmin;">{{loc.cf_deal_summary.substring(0,200)}}</h6>
                              </div>
                              <br />
                            </div>
                            <div class="listing-bottom">
                              <div class="col-6 text-left listing-shotleft" style="padding-top:0;">
                                <a href="/" class="listing-price">{{loc.cf_destinations[0].mx_city}}</a>
                              </div>
                              <div class="col-6 text-right listing-shotright" style="padding-top:0;">
                                <a (click)="goToDeals(loc.url_title)" class="listing-open">Explore more ></a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
  <!--Right Navigation-->
  <button class="custom-nav-button next-button" (click)="nextSlide()">
    <i class="fas fa-solid fa-arrow-right"></i>
  </button>
</div>